import { IBankServiceMock } from './payment-plan.mock.types';

export const mockBankService = (): IBankServiceMock => ({
  fetchBanks: jest.fn(),
  fetchBank: jest.fn(),
  createBank: jest.fn(),
  updateBank: jest.fn(),
  deleteBank: jest.fn(),
  //BankPaymentInstruction
  fetchBankPaymentInstructions: jest.fn(),
  fetchBankPaymentInstruction: jest.fn(),
  createBankPaymentInstruction: jest.fn(),
  updateBankPaymentInstruction: jest.fn(),
  deleteBankPaymentInstruction: jest.fn(),

  //BankPaymentInstructionProperty
  fetchBankPaymentInstructionProperties: jest.fn(),
  fetchBankPaymentInstructionProperty: jest.fn(),
  createBankPaymentInstructionProperty: jest.fn(),
  updateBankPaymentInstructionProperty: jest.fn(),
  deleteBankPaymentInstructionProperty: jest.fn()
});
